import { render, staticRenderFns } from "./SubmitButtonComponent.vue?vue&type=template&id=f870264e"
import script from "./SubmitButtonComponent.vue?vue&type=script&lang=ts"
export * from "./SubmitButtonComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports